import {UserRole} from "@/shared/enums/UserRolesEnums";
import PrivateCoachingList from "@/views/App/Analytics/Accounting/PrivateCoaching/List.vue";
import AssistedLivingCoachingList from "@/views/App/Analytics/Accounting/AssistedLivingCoaching/List.vue";
import SocioTherapyCoachingList from "@/views/App/Analytics/Accounting/SocioTherapyCoaching/List.vue";
import PrivateLearningCoachingList from "@/views/App/Analytics/Accounting/PrivateLearningCoaching/List.vue";

const routesAnalyticsAccounting = [
    {
        path: "accounting/private-coaching/list",
        name: "analyticsAccountingPrivateCoachingList",
        component: PrivateCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
            ]
        },
    },
    {
        path: "accounting/socio-therapy-coaching/list",
        name: "analyticsAccountingSocioTherapyCoachingList",
        component: SocioTherapyCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
            ]
        },
    },
    {
        path: "accounting/assisted-living-coaching/list",
        name: "analyticsAccountingAssistedLivingCoachingList",
        component: AssistedLivingCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
            ]
        },
    },
    {
        path: "accounting/assisted-learning-coaching/list",
        name: "analyticsAccountingPrivateLearningCoachingList",
        component: PrivateLearningCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ACCOUNTANT,
            ]
        },
    },
]

export default routesAnalyticsAccounting;